import { UtilityService } from '@eforall/common';
import { GridSetup, DialogService } from '@eforall/dashboard';
import { SessionRow } from '../sessions-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';


export function getSetup(util: UtilityService, dialog: DialogService, areaService: AcceleratorAreaService): GridSetup<SessionRow> {

	return {
		rowName: { singular: 'Session', plural: 'Sessions' },
		getRowKey: row => '' + row.accSessionId,
		stateKey: 'accelerator-sessions-grid',
		actions: getActions(dialog, areaService),
		buttons: [],
		columns: getColumns(util),
	}
}
